/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import { Crate } from '@piwikpro/platform';
import HttpCrate from '@piwikpro/http-crate';
import NotificationCrate from '@piwikpro/notification-crate';
import FormCrate from '@piwikpro/form-crate';
import TranslationCrate from '@piwikpro/translation-crate';
import TitleCrate from '@piwikpro/title-crate';
import RouterCrate from '@piwikpro/router-crate';
import { TrackerSettings } from './TrackerSettings';
import trackerSettings from './redux';

import GlobalAppSettings from './components/GlobalAppSettings';
import Urls from './components/AppSettings/Urls';
import ExcludeUnknownUrls from './components/AppSettings/ExcludeUnknownUrls';
import KeepUrlFragment from './components/AppSettings/KeepUrlFragment';
import CampaignContentParams from './components/AppSettings/CampaignContentParams';
import CampaignSourceParams from './components/AppSettings/CampaignSourceParams';
import CampaignNameParams from './components/AppSettings/CampaignNameParams';
import CampaignMediumParams from './components/AppSettings/CampaignMediumParams';
import CampaignKeywordParams from './components/AppSettings/CampaignKeywordParams';
import CampaignIdParams from './components/AppSettings/CampaignIdParams';
import SearchCategoryAndQueryParams from './components/AppSettings/SearchCategoryAndQueryParams';
import ExcludedIps from './components/AppSettings/ExcludedIps';
import ExcludedUrlQueryParams from './components/AppSettings/ExcludedUrlQueryParams';
import ExcludedUserAgents from './components/AppSettings/ExcludedUserAgents';
import ExcludeCrawlers from './components/AppSettings/ExcludeCrawlers';
import CreateNewVisitWhenCampaignChanges from './components/AppSettings/CreateNewVisitWhenCampaignChanges';
import CreateNewVisitWhenReferrerChanges from './components/AppSettings/CreateNewVisitWhenReferrerChanges';
import StripSiteSearchQueryParams from './components/AppSettings/StripSiteSearchQueryParams';
import AppPrivacy from './components/AppSettings/Privacy';
import MaxSessionTime from './components/AppSettings/MaxSessionTime';
import MaxSessionEventCount from './components/AppSettings/MaxSessionEventCount';
import ActionOnSessionLimitExceeded from './components/AppSettings/ActionOnSessionLimitExceeded';

@Crate({
  name: 'TrackerSettingsCrate',
  imports: [
    HttpCrate,
    NotificationCrate,
    FormCrate,
    TitleCrate,
    TranslationCrate,
    RouterCrate,
  ],
  services: [
    { name: 'tracker', provide: TrackerSettings },
  ],
  reducers: {
    trackerSettings,
  },
  components: [
    { name: 'GlobalAppSettings', provide: GlobalAppSettings },
    { name: 'AppSettings.Urls', provide: Urls },
    { name: 'AppSettings.KeepUrlFragment', provide: KeepUrlFragment },
    { name: 'AppSettings.CampaignContentParams', provide: CampaignContentParams },
    { name: 'AppSettings.CampaignSourceParams', provide: CampaignSourceParams },
    { name: 'AppSettings.CampaignNameParams', provide: CampaignNameParams },
    { name: 'AppSettings.CampaignMediumParams', provide: CampaignMediumParams },
    { name: 'AppSettings.CampaignKeywordParams', provide: CampaignKeywordParams },
    { name: 'AppSettings.CampaignIdParams', provide: CampaignIdParams },
    { name: 'AppSettings.SearchCategoryAndQueryParams', provide: SearchCategoryAndQueryParams },
    { name: 'AppSettings.ExcludeUnknownUrls', provide: ExcludeUnknownUrls },
    { name: 'AppSettings.ExcludedIps', provide: ExcludedIps },
    { name: 'AppSettings.ExcludedUrlQueryParams', provide: ExcludedUrlQueryParams },
    { name: 'AppSettings.ExcludedUserAgents', provide: ExcludedUserAgents },
    { name: 'AppSettings.ExcludeCrawlers', provide: ExcludeCrawlers },
    { name: 'AppSettings.CreateNewVisitWhenCampaignChanges', provide: CreateNewVisitWhenCampaignChanges },
    { name: 'AppSettings.CreateNewVisitWhenReferrerChanges', provide: CreateNewVisitWhenReferrerChanges },
    { name: 'AppSettings.StripSiteSearchQueryParams', provide: StripSiteSearchQueryParams },
    { name: 'AppSettings.Privacy', provide: AppPrivacy },
    { name: 'AppSettings.MaxSessionTime', provide: MaxSessionTime },
    { name: 'AppSettings.MaxSessionEventCount', provide: MaxSessionEventCount },
    { name: 'AppSettings.ActionOnSessionLimitExceeded', provide: ActionOnSessionLimitExceeded },
  ],
})
export class TrackerSettingsCrate {}
